module.exports = __webpack_public_path__ + "img/t-shirt.801fac94.png";